import clsx from 'clsx'
import {ButtonsSwitchInput} from 'swayok-react-mdb-ui-kit/components/Input/ButtonsSwitchInput'
import type {AdPropertyConfigForFilters} from '../../../AdsModuleTypes'
import {FilterLabel} from './FilterLabel'

interface Props {
    config: AdPropertyConfigForFilters
    value: string | number | null
    onChange: (name: string, value: string | number | null) => void
    disabled?: boolean
    noLabel?: boolean
    className?: string
}

// Фильтр выбора одного значения из списка в виде переключателя.
export function ButtonsSwitchFilter(props: Props) {

    const {
        config,
        value = null,
        className = 'pb-4',
        disabled,
        noLabel,
        onChange,
    } = props

    const {
        label,
        options = [],
        className: classNameFromConfig,
    } = config.props

    if (options.length === 0) {
        // Нет опций - нечего показывать.
        return null
    }

    return (
        <div
            className={clsx(
                className,
                classNameFromConfig
            )}
        >
            {!noLabel && (
                <FilterLabel
                    label={label}
                    disabled={disabled}
                />
            )}
            <ButtonsSwitchInput<string | number | null>
                options={options}
                value={value}
                className="m-0"
                buttonsProps={{
                    style: {
                        minWidth: 80,
                    },
                }}
                onChange={value => onChange(config.name, value)}
                disabled={disabled}
            />
        </div>
    )
}
